import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(res.data);
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-secondary">
      <div className="flex flex-col items-center gap-4 text-foreground">
        <Loader2 className="h-10 w-10 animate-spin text-accent" />
        <p className="font-heading font-semibold text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
